import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';

export interface IFilterIconProps extends IConDefaultType {}

function FilterIcon({ color, className, size = 24, rotate = 0, flip }: IFilterIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(20.4 3) rotate(90)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 12C2.0058 12 1.2 11.1942 1.2 10.2C1.2 9.2064 2.0058 8.4 3 8.4C3.9942 8.4 4.8 9.2064 4.8 10.2C4.8 11.1942 3.9942 12 3 12ZM3.6 7.26061V0.6C3.6 0.2688 3.3318 0 3 0C2.6682 0 2.4 0.2688 2.4 0.6V7.26061C1.0308 7.53841 0 8.7486 0 10.2C0 11.6514 1.0308 12.8616 2.4 13.1394V16.2C2.4 16.5318 2.6682 16.8 3 16.8C3.3318 16.8 3.6 16.5318 3.6 16.2V13.1394C4.9692 12.8616 6 11.6514 6 10.2C6 8.7486 4.9692 7.53841 3.6 7.26061ZM9 6C8.0058 6 7.2 5.1942 7.2 4.2C7.2 3.2064 8.0058 2.4 9 2.4C9.9942 2.4 10.8 3.2064 10.8 4.2C10.8 5.1942 9.9942 6 9 6ZM9.6 1.26061V0.6C9.6 0.2688 9.3318 0 9 0C8.6682 0 8.4 0.2688 8.4 0.6V1.26061C7.0308 1.53841 6 2.7486 6 4.2C6 5.6514 7.0308 6.86159 8.4 7.13939V16.2C8.4 16.5318 8.6682 16.8 9 16.8C9.3318 16.8 9.6 16.5318 9.6 16.2V7.13939C10.9692 6.86159 12 5.6514 12 4.2C12 2.7486 10.9692 1.53841 9.6 1.26061ZM15 14.4C14.0058 14.4 13.2 13.5942 13.2 12.6C13.2 11.6064 14.0058 10.8 15 10.8C15.9942 10.8 16.8 11.6064 16.8 12.6C16.8 13.5942 15.9942 14.4 15 14.4ZM15.6 9.66061V0.6C15.6 0.2688 15.3318 0 15 0C14.6682 0 14.4 0.2688 14.4 0.6V9.66061C13.0308 9.93841 12 11.1486 12 12.6C12 14.0514 13.0308 15.2616 14.4 15.5394V16.2C14.4 16.5318 14.6682 16.8 15 16.8C15.3318 16.8 15.6 16.5318 15.6 16.2V15.5394C16.9692 15.2616 18 14.0514 18 12.6C18 11.1486 16.9692 9.93841 15.6 9.66061Z"
            fill={color || EColorMap.gray_0}
          />
        </g>
      </svg>
    </i>
  );
}

export default FilterIcon;
